import {gsap} from "gsap";
import App from "../../../../templates/src/App/App.js";
import Shops from "@modules/navigator/Shops/Shops.js";

const ShopsBubble = {

    init() {
        this.el = $('[component="ShopsBubble"]');
        if (!this.el.length) return;

        console.log(this.el)

        this.name = this.el.find('.name');
        this.state = this.el.find('.state');
        this.total = this.el.find('.space-total .value');
        this.button = this.el.find('.button');

        this.bind();
    },

    bind() {
        document.addEventListener("mousemove", (evt) => {
            if (!App.isDesktop) return;
            this.move(evt);
        });

        this.button.click((evt)=>{
            Shops.onClick(evt)
        })
    },

    move(evt) {
        let shiftX, shiftY, left, top, alignT, alignL;
        const holder = Shops.el.find('.holder');
        const holderT = holder.offset().top;
        const holderL = holder.offset().left;
        const holderW = holder.innerWidth() / 2;
        const holderH = holder.innerHeight() / 2;

        // dolná polovica
        if (evt.clientY > holderT + holderH) {
            alignT = 'top';
            shiftY = this.el.outerHeight() - 40;
        } else {
            alignT = 'bottom';
            shiftY = -40;
        }

        // ľavá polovica
        if (evt.clientX > holderL + holderW) {
            shiftX = -this.el.outerWidth() - 40;
            alignL = 'left';
        } else {
            shiftX = 40;
            alignL = 'right';
        }

        top = (App.isTablet || App.isMobile) ?  evt.pageY - shiftY : evt.clientY - shiftY;

        if (App.isDesktop) {
            left = evt.clientX - holderL + shiftX;
        } else if (App.isTablet) {
            if(alignL === 'left') left = 32;
            else left = window.innerWidth - 32 - this.el.outerWidth();
        } else if (App.isMobile) {
            if(alignL === 'left') left = 20;
            else left = window.innerWidth - 20 - this.el.outerWidth();
        }

        if (App.isTablet || App.isMobile) {
            left = left - 40;
        }

        gsap.set(this.el, {top: top, left: left})
    },

    show(evt, area, data) {
        if (!data) return;
        this.prepare(data);
        if (evt.type === 'click') this.move(evt);
        gsap.set(this.el, {pointerEvents: 'all'});
        gsap.to(this.el, {opacity: 1, duration: 0.3})

        const flatLetter = data.name.replace(/\d+/g, '');
        this.button.attr('id', flatLetter)

        if (App.isMobile) {
            this.button.show(0);
        }
    },

    prepare(data) {
        if (!data) return;

        this.el.removeClass("available reserved sold dev");

        this.name.text(data.type + " " + data.name);
        this.state.text(NAVIGATOR_META.states[data.state]['text']);
        this.state.attr('state', NAVIGATOR_META.states[data.state]['key']);
        this.total.text(data.living_space);
    },

    hide() {
        gsap.set(this.el, {pointerEvents: 'none'})
        gsap.to(this.el, {opacity: 0, duration: 0.3})
    },
}

export default ShopsBubble;